export default __webpack_public_path__ + "static/media/EdgarEsmipinal.d95223f1.jpg";